import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Checkbox,
    Divider,
    FormControlLabel,
    FormGroup,
    Grid,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import * as Icon from "@mui/icons-material";
import { LocalizationProvider, MobileDateRangePicker } from '@mui/x-date-pickers-pro/';
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/';
import CustomTooltip from "../CustomTooltip";
import dayjs from "dayjs";
import { LicenseInfo } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { capitalizeWords, empty, generatePhrase, getDateToString, toastMessage } from "../../utils/common";
import { useNavigate } from "react-router";
import { UserAuth } from "../../store/context/userContext";
import { DesktopDateRangePicker } from '@mui/x-date-pickers-pro/DesktopDateRangePicker';
import { CommonContext } from "../../store/context/commonContext";
import errorAndHelperText from "../CommonConstants/errorAndHelperText.json"


LicenseInfo.setLicenseKey(
    "370e579ab4fef48a1739afecb9c68d3bTz04OTIyMyxFPTE3NDU3NTAwNTUwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y"
);

const BookingCard = ({
    packageSeq,
    // guests = 0,
    maxGuests,
    minGuests,
    minDays,
    maxDays,
    price = 1,
    notAvailableDates = [],
    // handleGuestChange = () => { },
    handleDateChange = () => { },
    isPopup = false,
    optionalAddOns = [],
    nonMandatoryCount = 0,
    totalNonZeroAmount = 0,
    platformFee
}) => {
    const { user, authPopup, setAuthPopup } = UserAuth();
    const openAuthPopup = (type) => {
        setAuthPopup({
            ...authPopup,
            type: type,
            open: true,
            callback: () => {
                handleCheckOut();
            },
        });
    };

    //pricing section related options
    const [selectedOptions, setSelectedOptions] = useState(() => {
        // Set initial selected options based on is_mandatory
        return optionalAddOns.filter(option => option.is_mandatory);
    });
    // console.log(selectedOptions);

    // //  console.log(selectedOptions);

    const handleOptionChange = (option) => {
        if (selectedOptions.some((selectedOption) => selectedOption.caption === option.caption)) {
            // If option already exists in selectedOptions, remove it
            setSelectedOptions(selectedOptions.filter((selectedOption) => selectedOption.caption !== option.caption));
        } else {
            // Otherwise, add it
            setSelectedOptions([...selectedOptions, option]);
        }
    };


    const [selectedDays, setSelectedDays] = useState(minDays);

    const [selectionPriceSum, setSelectionPriceSum] = useState(0)
    const [selectionNames, setSelectionNames] = useState('')

    const navigate = useNavigate();
    const today = dayjs()

    let defaultBookingSelection = [null, null]
    let defaultGuestsSelection = parseInt(minGuests)


    if (localStorage.getItem(`${packageSeq}-bookingSelection`) != null) {
        const localStorageBookingSelection = JSON.parse(localStorage.getItem(`${packageSeq}-bookingSelection`))
        defaultBookingSelection = [dayjs(localStorageBookingSelection.startDate), dayjs(localStorageBookingSelection.endDate)]
        defaultGuestsSelection = parseInt(localStorageBookingSelection.guest)
    }

    const [guests, setGuests] = useState(defaultGuestsSelection)
    const [dateRange, setDateRange] = useState(defaultBookingSelection);

    const [openDate, setOpenDate] = useState(false)
    const { isNineHundred } = CommonContext()

    const [errorText, setErrorText] = useState('')
    const [dateError, setDateError] = useState(false)

    const handleSetSelectedDaysCount = (days) => {
        setSelectedDays(isNaN(days) ? 0 : days);
    }


    function dateRangeContainsUnavailable(dateRange, unavailableDates) {

        const start = dayjs(dateRange[0])
        const end = dayjs(dateRange[1])

        for (let date of unavailableDates) {
            if (date.isBetween(start - 1, end + 1)) {
                return true
            }
        }

        return false
    }

    const handleGuestChange = (event) => {
        const selectedGuests = parseInt(event.target.value, 10);

        // Ensure selected guests are within the allowed range
        if (selectedGuests >= minGuests && selectedGuests <= maxGuests) {
            setGuests(selectedGuests.toString());
        }

        let storedSelection = JSON.parse(localStorage.getItem(`${packageSeq}-bookingSelection`));
        if (storedSelection != null) {
            storedSelection.guest = selectedGuests;
            localStorage.setItem(`${packageSeq}-bookingSelection`, JSON.stringify(storedSelection));
        }
    };

    const setDates = (date) => {


        if (minDays == maxDays && date[1] != null) {

            if ((date[0] ? date[0].format('YYYY-MM-DD') : null) !== (dateRange[0] ? dateRange[0].format('YYYY-MM-DD') : null)) {
                if (date[0]) {
                    date[1] = dayjs(date[0]).add(minDays - 1, 'day');
                    setDateRange(date)
                    setOpenDate(false)
                    return
                }
            }
            date[0] = date[1]
            date[1] = dayjs(date[0]).add(minDays - 1, 'day');
            setDateRange(date);
        } else {
            if (minDays == maxDays) {
                date[1] = dayjs(date[0]).add(minDays - 1, 'day');
                setDateRange(date);
            } else {
                // Check if both formatted end dates are equal 
                if (dayjs(date[1]).format('YYYY-MM-DD') === dayjs(dateRange[1]).format('YYYY-MM-DD')) {
                    date[1] = null;
                    setOpenDate(true);
                    setDateRange(date)
                } else {
                    setDateRange(date)
                }
            }
        }
        // if user press back button user should have it's previous selection 
        localStorage.setItem(`${packageSeq}-bookingSelection`, JSON.stringify({
            guest: guests,
            startDate: getDateToString(dayjs(date[0])),
            endDate: getDateToString(dayjs(date[1]))
        }));

    }

    const [dateSelectText, setDateSelectText] = useState('')


    const disableCustomDates = (date) => {
        return date.isSame(today, 'day')
            || (notAvailableDates.length > 0 && notAvailableDates.some(d => date.isSame(d, 'day')));
    };


    const handleCheckOut = () => {
        if (empty(user)) {
            openAuthPopup("signin");
            return;
        }
        if (empty(guests) || empty(dateRange[0]) || empty(dateRange[1])) {
            toastMessage(errorAndHelperText.booking_card.selection)
            setErrorText(errorAndHelperText.booking_card.selection.message)
            setDateError(true)
            return;
        }

        const startDateParam = "&sd=" + getDateToString(dateRange[0]);
        const endDateParam = "&ed=" + getDateToString(dateRange[1]);
        const packageSeqParam = "&p=" + packageSeq;
        const selectionParam = "&sel=" + selectionNames;

        navigate(
            "/checkout?g=" +
            guests +
            startDateParam +
            endDateParam +
            packageSeqParam +
            selectionParam
        );
    };

    let dateHelperText = ''

    if (minDays == maxDays) {
        dateHelperText = `This package can be booked for ${generatePhrase(minDays, 'day')}.`
    } else if (minDays != maxDays) {
        dateHelperText = `This package can be booked for ${minDays}-${maxDays} days.`
    }

    useEffect(() => {

        let days = dayjs(dateRange[1]).diff(dateRange[0], 'days') + 1;

        if (dateRange[0] == null || dateRange[1] == null) {
            setDateSelectText('Select Dates')
        } else if (dateRange[0].format('YYYY-MM-DD') == dateRange[1].format('YYYY-MM-DD')) {
            const invalidCheck = dateRange[0].format('MMM DD, YYYY')
            if (invalidCheck.includes('Invalid')) {
                setDateRange([null, null])
                return
            }
            setDateSelectText(`${dateRange[0].format('MMM DD, YYYY')}`)
        } else {
            const invalidCheck = `${dateRange[0].format('MMM DD, YYYY')}${dateRange[1].format('MMM DD, YYYY')}`
            if (invalidCheck.includes('Invalid')) {
                setDateRange([null, null])
                return
            }
            setDateSelectText(`${dateRange[0].format('MMM DD, YYYY')} - ${dateRange[1].format('MMM DD, YYYY')}`)
        }

        if (dateRange[0] != null && dateRange[1] != null) {
            setOpenDate(false)
        }

        if (isNaN(days) || (dateRange[0] === null) || (dateRange[1] === null)) {
            setErrorText(errorAndHelperText.booking_card.valid_range.message)
            setDateError(true)
        }

        if (dateRangeContainsUnavailable(dateRange, notAvailableDates)) {
            setErrorText(errorAndHelperText.booking_card.unavailable_dates.message)
            setDateError(true)
            return
        }


        if (days < minDays) {
            setErrorText(`You can not book this package for less than ${minDays} days.`)
            setDateError(true)
        } else if (days > maxDays) {
            setErrorText(`You can not book this package for more than ${maxDays} days.`)
            setDateError(true)
        } else {
            if (empty(dateRange[0]) || empty(dateRange[1])) {
                setErrorText("")
            } else {
                if (days === 1) {
                    setErrorText('This date is available.')
                } else {
                    setErrorText('These dates are available.')
                }
            }
            setDateError(false)
        }
        handleSetSelectedDaysCount(days)

        handleDateChange(dateRange);


    }, [notAvailableDates, dateRange, guests]);

    if (isNaN(selectedDays)) {
        setSelectedDays(0)
    }


    useEffect(() => {
        if (!Array.isArray(selectedOptions) || selectedOptions.length === 0) {
            setSelectionPriceSum(0);
            setSelectionNames('');
            return;
        }

        let tempStr = '';
        let sum = 0;
        const daysToUse = Math.max(selectedDays, minDays);
        if (daysToUse > 1) {
            selectedOptions.forEach((option, index) => {
                const amount = parseFloat(option.amount);
                if (!isNaN(amount)) {
                    sum += amount * (option.is_per_day ? selectedDays - 1 : 1);
                }
                tempStr += option.caption;
                if (index < selectedOptions.length - 1) {
                    tempStr += ',';
                }
            });
        }
        setSelectionPriceSum(sum);
        setSelectionNames(tempStr);
    }, [selectedOptions, selectedDays, minDays]);

    let total_package_price =
        price * (guests ? parseInt(guests) : minGuests) * (selectedDays > minDays ? selectedDays : minDays);
    let booking_fee = parseFloat(((total_package_price + selectionPriceSum) * (platformFee / 100)).toFixed(2));
    let conservation_donation = 0;

    return (
        <Grid item xs={12} sm={12} md={5}>
            <Box
                sx={{
                    p: { xs: 2, sm: 2, md: 3, lg: 3 },
                    border: "1px solid var(--grey500)",
                    borderRadius: (theme) => `${theme.card.borderRadius} `,
                    position: "sticky",
                    top: "100px",
                    "& .MuiTypography-root": {
                        color: 'var(--grey900)'
                    },
                }}
                variant="outlined"
            >
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Typography >From &nbsp;</Typography>
                    <Box sx={{ display: 'flex', gap: 1, }}>
                        <Box sx={{
                            "& .MuiTypography-root": {
                                color: 'var(--black)'
                            }
                        }}>
                            <Typography style={{ fontWeight: "600" }}> ${parseFloat(price).toFixed(2)} &nbsp;</Typography>
                        </Box>
                    </Box>
                    <Typography>per guest</Typography>
                </Box>
                <Box sx={{
                    display: 'flex', mb: 2, justifyContent: 'space-between', color: 'var(--grey900)',

                }}>
                    <Typography>Package Includes</Typography>
                    <Box sx={{ display: 'flex' }}>
                        <Box sx={{
                            display: 'flex', alignItems: 'center', gap: 1, "& .MuiTypography-root": {
                                fontSize: '14px'
                            },
                        }}>
                            <Icon.PersonOutlineOutlined sx={{ fontSize: '17.5px;' }} />
                            <Typography >
                                {generatePhrase(guests, 'Guest')}
                            </Typography>
                            <Icon.CalendarTodayOutlined sx={{ fontSize: '14px' }} />
                            <Typography >
                                {generatePhrase(selectedDays > minDays ? selectedDays : minDays, 'Day')}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box
                    sx={{
                        borderRadius: (theme) => `${theme.card.borderRadiusMd} `,
                        mb: 3,
                        backgroundColor: 'var(--grey300)'
                    }}
                >
                    <Box sx={{ display: "flex", p: "0.75rem 1rem", flexDirection: 'column', gap: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography>
                                Select the Number of Guests
                            </Typography>
                        </Box>

                        <Box>
                            <Select
                                displayEmpty
                                value={guests} // Set the value to defaultGuestsSelection
                                fullWidth
                                IconComponent={Icon.KeyboardArrowDownOutlined}
                                onChange={handleGuestChange}
                                sx={{
                                    height: "42px",
                                    backgroundColor: 'white'
                                }}
                            >
                                {Array.from({ length: maxGuests - minGuests + 1 }, (_, index) => (
                                    <MenuItem
                                        key={index + parseInt(minGuests)}
                                        value={index + parseInt(minGuests)}
                                    >
                                        {index + parseInt(minGuests)}
                                    </MenuItem>
                                ))}
                            </Select>

                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", p: "1rem", flexDirection: 'column', gap: 1 }}>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <Typography>Choose Trip Dates</Typography>
                        </Box>

                        <Box sx={{
                            height: 0,
                            overflow: 'hidden',

                            '& :hover': {
                                cursor: 'pointer',
                            },
                            "& .MuiFormHelperText-root": {
                                ml: 0,
                                color: 'green'
                            },
                            "&. MuiTextField-root": {
                                display: 'none'
                            },
                            mt: 2,
                        }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                {!isNineHundred ?
                                    <Box sx={{
                                        height: 0
                                    }}>
                                        <DesktopDateRangePicker
                                            open={openDate}
                                            // autoFocus
                                            calendars={1}
                                            clearable={true}
                                            slots={{ field: SingleInputDateRangeField }}
                                            // label="Select Dates"
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                },
                                                actionBar: { actions: ["clear"] },

                                            }}
                                            sx={{
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': {
                                                    backgroundColor: 'white',
                                                },
                                                "&. MuiInputBase-root": {
                                                    display: 'none'
                                                },
                                                "& .MuiFormControl-root": {
                                                    display: 'none'
                                                }
                                            }}
                                            format="DD MMM YYYY"
                                            onOpen={() => setOpenDate(true)}
                                            // use this if Ok button is needed
                                            // onAccept={()=>{
                                            //     setOpenDate(false)
                                            // }}
                                            value={dateRange}
                                            onChange={(date) => setDates(date)}
                                            disablePast
                                            disableHighlightToday
                                            shouldDisableDate={disableCustomDates}
                                            onClose={() => setOpenDate(false)}
                                        />
                                    </Box>
                                    :
                                    <MobileDateRangePicker
                                        open={openDate}
                                        calendars={1}
                                        clearable={true}
                                        slots={{ field: SingleInputDateRangeField }}
                                        // label="Select Dates"
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                InputProps: { endAdornment: <Icon.CalendarMonth />, placeholder: 'Select Dates' },
                                                error: !!dateError,
                                                helperText: errorText
                                            },
                                            actionBar: { actions: ["clear"] },

                                        }}
                                        sx={{
                                            width: '100%',
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: 'white',

                                            }
                                        }}
                                        format="DD MMM YYYY"
                                        value={dateRange}
                                        onChange={(date) => setDates(date)}
                                        disablePast
                                        disableHighlightToday
                                        closeOnSelect
                                        shouldDisableDate={disableCustomDates}
                                        onClose={() => setOpenDate(false)}
                                    />}
                            </LocalizationProvider>
                        </Box>
                        <TextField
                            sx={{
                                zIndex: '99',
                                marginTop: '-28px',
                                borderRadius: '6px',
                                // transition: 'border-color 0.3s', // Add transition for smooth effect
                                color: 'var(--black)',
                                '& :hover': {
                                    cursor: 'pointer'
                                },
                                '& .MuiOutlinedInput-root': {
                                    backgroundColor: 'white',
                                },
                                "&. MuiInputBase-root": {
                                    display: 'none',
                                },
                                "& .MuiFormControl-root": {
                                    display: 'none'
                                }, "& .MuiFormHelperText-root": {
                                    ml: 0,
                                    color: 'var(--primary)'
                                }, "& .MuiInputBase-input": {
                                }, "& .Mui-error": {
                                    color: '#d32f2f'
                                }
                            }}
                            InputProps={{
                                endAdornment: <Icon.CalendarToday />,
                                style: { color: 'black' },
                                inputProps: { style: { color: 'black' } }
                            }}
                            error={!!dateError}
                            helperText={errorText}
                            autoComplete="off"
                            size="small"
                            value={dateSelectText}
                            onClick={(e) => {
                                e.preventDefault();
                                setOpenDate(!openDate)
                            }}
                            onKeyDown={(e) => e.preventDefault()} // Prevent typing inside TextField
                        />

                        <Typography variant="caption">
                            {dateHelperText}
                        </Typography>
                        {nonMandatoryCount > 0 && totalNonZeroAmount > 0 && (selectedDays > minDays ? selectedDays : minDays) > 1 && <Box>
                            <Typography sx={{ mb: 1 }} >Available Add-ons</Typography>
                            <FormGroup
                                sx={{
                                    "& .MuiFormControlLabel-root": { height: '24px' },
                                    "& .MuiCheckbox-root": { padding: 0 },
                                    pl: 1
                                }}
                            >
                                {optionalAddOns.map((option) => {
                                    // //  console.log(option)
                                    return (
                                        !option.is_mandatory && option.amount != 0 &&
                                        <FormControlLabel
                                            key={option.caption}
                                            control={
                                                <Checkbox
                                                    defaultChecked={option.is_mandatory}
                                                    checked={selectedOptions.some((selectedOption) => selectedOption.caption === option.caption)}
                                                    onChange={() => handleOptionChange(option)}
                                                    disabled={option.is_mandatory}
                                                />
                                            }
                                            label={`${capitalizeWords(option.caption)} $${option.amount}${option.is_per_day ? `/Night` : ''}`}
                                        />
                                    )
                                })}
                            </FormGroup>
                        </Box>}

                    </Box>
                </Box>
                {window.location.pathname !== '/checkout' && <Button
                    fullWidth
                    size="large"
                    variant="contained"
                    sx={isPopup ? { display: 'none' } : { mb: 3 }}
                    onClick={handleCheckOut}
                    disabled={dateError}
                >
                    Continue to Booking
                </Button>}
                <Box sx={{}}>
                    <Box sx={{
                        display: "flex", alignItems: "center", gap: 1, "& .MuiTypography-root": {
                            color: 'var(--black)'
                        }
                    }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: "600" }}>
                            Pricing Details
                        </Typography>
                        <CustomTooltip
                            content={
                                <>The amount paid is inclusive of the FarWide fee. </>
                            }
                        />
                    </Box>
                    <Typography variant="caption">
                        Prices are for exclusive access to this property.
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                        <Box>{`$${parseFloat(price).toFixed(2)} x ${generatePhrase(guests, 'Guest')} x ${generatePhrase(selectedDays > minDays ? selectedDays : minDays, 'Day')}`}</Box>
                        <Box>${isNaN(total_package_price) ? 0 : parseFloat(total_package_price).toFixed(2)}</Box>
                    </Box>
                    {selectedOptions.map((option) => (
                        (selectedDays > minDays ? selectedDays : minDays) > 1 &&
                            isNaN(option.amount) ? 0 : parseFloat(option.amount * (option.is_per_day ? selectedDays - 1 : 1)).toFixed(2) != 0 &&
                        <Box sx={{ display: "flex", justifyContent: "space-between" }} key={option.caption}>
                            <Box>${isNaN(option.amount) ? 0 : parseFloat(option.amount).toFixed(2)} x {option.is_per_day && `${generatePhrase(selectedDays > minDays ? selectedDays - 1 : minDays - 1, 'Night')} (${capitalizeWords(option.caption)})`}</Box>
                            <Box>${isNaN(option.amount) ? 0 : parseFloat(option.amount * (option.is_per_day ? (selectedDays > minDays ? selectedDays : minDays) - 1 : 1)).toFixed(2)}</Box>
                        </Box>
                    ))}
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Box>Platform Fee ({platformFee}%)</Box>
                        <Box>${isNaN(booking_fee) ? 0 : parseFloat(booking_fee).toFixed(2)}</Box>
                    </Box>
                    {/* <Box
                sx={{ display: "flex", justifyContent: "space-between" }}
            >
                <Box>Conservation Donation</Box>
                <Box sx={{ textAlign: "right" }}>+${conservation_donation}</Box>
            </Box> */}
                    <Divider sx={{ my: 1 }} />
                    <Box
                        sx={{
                            display: "flex",
                            fontWeight: "600",
                            justifyContent: "space-between",
                            color: 'var(--grey900)'
                        }}
                    >
                        <Box sx={{ color: 'var(--black)' }}>Total</Box>
                        <Box sx={{ color: 'var(--black)' }}>
                            ${isNaN(total_package_price + conservation_donation + booking_fee) ? 0 : (parseFloat(total_package_price + conservation_donation + booking_fee + (selectionPriceSum)).toFixed(2))}
                        </Box>
                    </Box>
                </Box>
            </Box>
            {isPopup &&
                <Box
                    sx={{
                        width: '100%',
                        ml: -2,
                        height: '82px',
                        position: 'fixed',
                        bottom: 0,
                        backgroundColor: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: '0 -2px 4px 0 rgba(0,0,0,0.15)',
                        zIndex: '9999',
                        pl: 2,
                        pr: 2
                    }}
                >

                    <Button
                        fullWidth
                        size="large"
                        variant="contained"
                        disabled={dateError}
                        onClick={handleCheckOut}
                        sx={{ mt: 'auto', mb: 'auto' }} // Vertically center the button

                    >
                        Continue to Booking
                    </Button>

                </Box>
            }
        </Grid >
    );
};

export default BookingCard;